import { lazy } from 'react';

// ============================================
// AUTHENTICATION & REGISTRATION ROUTES
// ============================================
export const LoginPage = lazy(() => import('pages/Register/Login'));
export const CreateAccount = lazy(() => import('pages/Register/CreateAccount'));
export const OtpPage = lazy(() => import('pages/Register/Otp'));
export const Login2FAOtp = lazy(() => import('pages/Register/Login2FAOtp'));
export const ForgetPage = lazy(() => import('pages/Register/Forget'));
export const ForgetPasswordOtpPage = lazy(() => import('pages/Register/ForgetPasswordOtp'));
export const ResetPassword = lazy(() => import('pages/Register/ResetPassword'));
export const AddPasswordPage = lazy(() => import('pages/Register/AddPassoword'));
export const AccVerified = lazy(() => import('pages/Register/AccVerified'));
export const BankDetails = lazy(() => import('pages/Register/BankDetails'));
export const Gst = lazy(() => import('pages/Register/Gst'));
export const PricingDetails = lazy(() => import('pages/Register/PricingDetails'));
export const PlanPricingDetails = lazy(() => import('pages/Register/PlanPricingDetails'));
export const MembershipRenewal = lazy(() => import('pages/Register/membershipRenewal'));

// ============================================
// PRODUCT ROUTES - BUYING PAGES
// ============================================
export const ElectronicsDetails = lazy(() => import('pages/Product/ProductBuyingPages/ElectronicsDetails'));
export const MediaBuying = lazy(() => import('pages/Product/ProductBuyingPages/MediaBuying'));
export const MultiplexMediaBuying = lazy(() => import('pages/Product/ProductBuyingPages/MultiplexMediaBuying'));
export const DigitalAndHoardingBuying = lazy(() => import('pages/Product/ProductBuyingPages/DigitalAndHoardingBuying'));
export const VoucherBuyingPage = lazy(() =>
  import('pages/Product/ProductBuyingPages/VoucherBuyingPage').then((module) => ({
    default: module.default || module.ProductDetails || module.VoucherBuyingPage,
  }))
);
export const GiftAndValueVoucherDetails = lazy(() => import('pages/Product/ProductBuyingPages/GiftAndValueVoucherDetails'));
export const WishlistMediaBuying = lazy(() => import('pages/Product/ProductBuyingPages/WishlistMediaBuying'));
export const WishlistVoucherBuyingPage = lazy(() => import('pages/Product/ProductBuyingPages/WishlistVoucherBuyingPage'));

// ============================================
// PRODUCT ROUTES - PREVIEW PAGES (listing journey moved to Standalone-Listing-Journey)
// Only voucher view routes kept for invoice/order flows
// ============================================
export const TextilesVoucherPrev = lazy(() => import('pages/Product/ProductPreviewPages/TextilesVoucherPrev'));
export const VoucherTypeOne = lazy(() => import('pages/Product/ProductPreviewPages/VoucherTypeOne'));
export const VoucherTypeTwo = lazy(() => import('pages/Product/ProductPreviewPages/VoucherTypeTwo'));

// ============================================
// CART & WISHLIST
// ============================================
export const Cart = lazy(() => import('pages/CartPage/CartPage'));
export const Wishlist = lazy(() => import('pages/WishlistPage/WishlistPage'));
export const WishlistProductDetails = lazy(() => import('pages/WishlistPage/Wishlistproductdetails'));

// ============================================
// MARKETPLACE
// ============================================
export * from './lazyRoutes.marketplace';

// ============================================
// PAYMENT
// ============================================
export const AddPayment = lazy(() => import('pages/Payment/AddPayment'));
export const MyWallet = lazy(() => import('pages/Payment/MyWallet'));

// ============================================
// STATUS PAGES (create-account flow)
// ============================================
export const BeingVerifiedPage = lazy(() => import('pages/BeingVerifiedPage'));
export const RejectPage = lazy(() => import('pages/RejectPage'));
export const UnderReviewPage = lazy(() => import('pages/UnderReviewPage'));

// ============================================
// INVOICES & DOCUMENTS
// ============================================
export const TaxInvoice = lazy(() => import('pages/TaxInvoice'));
export const BuyerTaxInvoice = lazy(() => import('pages/OrderRequest/BuyerTaxInvoice'));
export const ShippingInvoice = lazy(() => import('pages/ShippingInvoice'));
export const VoucherTaxInvoice = lazy(() => import('pages/VoucherTaxInvoice'));
export const MediaTaxInvoice = lazy(() => import('pages/MediaTaxInvoice'));
export const MembershipFeesInvoice = lazy(() => import('features/membership/pages/MembershipFeesInvoice'));
export const MembershipRenewalInvoice = lazy(() => import('features/membership/pages/MembershipRenwalInvoice'));
export const Invoice = lazy(() => import('pages/Product/Invoice'));
export const InvoicePage = lazy(() => import('pages/Product/Invoicelist'));
export const PerformaInvoice = lazy(() => import('pages/Product/Calend/PerformaInvoice'));
export const ProformaInvoice = lazy(() => import('pages/PoPiTaxPages/ProformaInvoice'));
export const VoucherProformaInvoice = lazy(() => import('pages/PoPiTaxPages/VoucherProformaInvoice'));

// ============================================
// TERMS & CONDITIONS (Dashboard only)
// ============================================
export const Conditions = lazy(() => import('pages/Conditions'));
export const TermsCondition = lazy(() => import('pages/TermsCondition'));

// ============================================
// PRODUCT MANAGEMENT - ADD PRODUCT (moved to Standalone-Listing-Journey)
// ============================================
// All add-product / bulk-upload / voucher-edit routes removed from dashboard.

// ============================================
// BULK PURCHASE
// ============================================
export const BulkPurchasePage = lazy(() => import('pages/BulkPurchase/BulkPurchasePage'));
export const BulkPurchaseListPage = lazy(() => import('pages/BulkPurchase/BulkPurchaseListPage'));
export const SmartBulkPurchasePage = lazy(() => import('pages/BulkRequirement/SmartBulkPurchasePage'));

// ============================================
// HOTEL PLANNER
// ============================================
export const HotelPlannerPage = lazy(() => import('pages/HotelPlanner/HotelPlannerPage'));
export const HotelPlannerPageList = lazy(() => import('pages/HotelPlanner/HotelPlannerPageList'));

// ============================================
// ORDER MANAGEMENT
// ============================================
export const OrderDetailsPage = lazy(() => import('pages/OrderDetailsPage/AllOrderList'));
export const TrackYourOrderPage = lazy(() => import('pages/OrderDetailsPage/TrackYourOrder'));
export const OrderDetailsForSeller = lazy(() => import('pages/OrderDetailsPage/OrderDetailsForSeller'));
export const DetailedOrderSummary = lazy(() => import('pages/OrderDetailsPage/DetailedOrderSummary'));
export const Commission = lazy(() => import('pages/OrderDetailsPage/Commission'));
export const CommissionByOrderId = lazy(() => import('pages/OrderDetailsPage/CommissionByOrderId'));
export const CommissionList = lazy(() => import('pages/OrderDetailsPage/CommissionList'));
export const BWTDSDebitNoteList = lazy(() => import('pages/BWTDSDebitNote/BWTDSDebitNoteList'));
export const BWTDSDebitNoteDetail = lazy(() => import('pages/BWTDSDebitNote/BWTDSDebitNoteDetail'));
export const BSCommission = lazy(() => import('pages/OrderDetailsPage/BSCommission'));
export const SellerOrderList = lazy(() => import('pages/OrderDetailsPage/SellerOrderList'));
export const VoucherOrderSummary = lazy(() => import('pages/OrderDetailsPage/VoucherOrderSummary'));

// ============================================
// Buying journey (Order Details / media PI lists — PO page stubs removed)
// ============================================
export * from './lazyRoutes.buying';

export const SellerDetailedOrderSummary = lazy(() => import('pages/PurchaseOrderList/SellerDetailedOrderSummary'));

// ============================================
// ORDER REQUEST (BXI Aggregator Mode) ROUTES
// ============================================
export const OrderRequestList = lazy(() => import('pages/OrderRequest/OrderRequestList'));
export const OrderRequestDetail = lazy(() => import('pages/OrderRequest/OrderRequestDetail'));
export const OrderRequestChooseTransport = lazy(() => import('pages/OrderRequest/OrderRequestChooseTransport'));
export const OrderRequestPaymentReturn = lazy(() => import('pages/OrderRequest/OrderRequestPaymentReturn'));
export const SellerProformaInvoiceDetails = lazy(() => import('pages/AllInvoices/SellerProformaInvoiceDetails'));

// ============================================
// VOUCHER MANAGEMENT
// ============================================
export const VoucherOrderList = lazy(() => import('pages/Voucher/VoucherOrderList'));
export const VoucherOrdeListSeller = lazy(() => import('pages/Voucher/VoucherOrdeListSeller'));

// ============================================
// HELP & FEEDBACK
// ============================================
export const HelpAndFeedbackPage = lazy(() => import('pages/HelpAndFeedback/HelpAndFeedbackPage'));

// ============================================
// MEMBER MANAGEMENT
// ============================================
export const CompanyMembers = lazy(() => import('pages/CompanyMembersPages/CompanyMembers'));
export const AddMember = lazy(() => import('pages/CompanyMembersPages/AddMember').then(module => ({ default: module.AddMember })));
export const EditMember = lazy(() => import('pages/CompanyMembersPages/EditMember'));
export const DeletedMembers = lazy(() => import('pages/CompanyMembersPages/DeletedMembers'));
export const MemberDetailsPage = lazy(() => import('pages/MemberDetails/MemberDetailsPage'));
export const MemberDirectory = lazy(() => import('pages/MemberDetails/MemberDirectory'));
export const AddUserPage = lazy(() => import('pages/MemberDetails/AddUserPage'));

// ============================================
// PRODUCT LISTING & MANAGEMENT
// ============================================
// MyListedProduct moved to Standalone-Listing-Journey
export const ProductAnalysis = lazy(() => import('pages/Product/ProductAnalysis'));
// ============================================
// PROFILE & SETTINGS
// ============================================
export const ProfileInterest = lazy(() => import('pages/Profile/ProfileInterest'));
export const MembershipDetail = lazy(() => import('pages/ViewProfile/MembershipDetail'));

// ============================================
// TRANSPORTATION
// ============================================
export const ChooseTransportation = lazy(() => import('pages/TransportationPage/ChooseTransportation'));

// ============================================
// MESSAGING
// ============================================

// ============================================
// EXPLORE PAGES
// ============================================
export const Products = lazy(() => import('pages/ExploreAllPages/Products'));

// ============================================
// AI VIEWS
// ============================================
export const AIMediaPlanner = lazy(() => import('pages/AIViews/MediaPlanner/AIMediaPlannerIndex'));

// ============================================
// OTHER PAGES
// ============================================
export const OfficeAppreal = lazy(() => import('pages/Apparel/OfficeAppreal'));
export const ProductDetails = lazy(() =>
  import('pages/Apparel/ProductDetails').then((module) => ({
    default: module.default || module.ProductDetails,
  }))
);
export const TransactionsPage = lazy(() => import('pages/Transactions'));
export const HtmlToPdfConverter = lazy(() => import('../utils/HtmlToPdfConverter'));
export const Unsubscribe = lazy(() => import('pages/Unsubscribe'));
// PhysicalDigital, PhysicalDigitalee, GeneralInfoParent, DynamicStep - listing journey, moved to Standalone

// ============================================
// TEMPLATE COMPONENTS (listing journey - moved to Standalone-Listing-Journey)
// ============================================

/**
 * Lazy load with retry mechanism for better reliability
 */
export const lazyWithRetry = (importFunc) => {
  return lazy(() =>
    importFunc().catch((error) => {
      return new Promise((resolve) => {
        setTimeout(() => {
          importFunc().then(resolve).catch(() => {
            resolve({ default: () => <div>Failed to load component. Please refresh the page.</div> });
          });
        }, 1000);
      });
    })
  );
};


